// extracted by mini-css-extract-plugin
export default {"item":"_9e283a2","xSmall":"_cf446cf0","small":"_3702e7c8","favorites":"_7a945b0","favoritesWrapper":"_dbca8443","favoritesIconWrapper":"_7b0bbe48","hideTile":"_c3d3e43"};